define('widgets/tournamentCard/viewmodel',['knockout'], function (ko) {

    function TournamentCard () {

        var self = this;

        self.showHints = false;
        self.isShowingHints = ko.pureComputed(function () {
            return self.showHints && self.tournament().currentPlayerOptedIn();
        });
    }

    TournamentCard.prototype.activate = function (settings) {
        var self = this;

        self.tournament = settings.tournament;
        self.showHints = !!settings.showHints;
    };

    return TournamentCard;
});


